import { put, takeLatest } from 'redux-saga/effects';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import request from 'utils/request';
import urls from 'utils/config';
import {
  setDeleteError,
  getCourse,
  setDeleteSuccess,
  clearStatus,
  getAllCourses,
} from '../actions';
import { CoursesActionTypes } from '../types';

const { API_BASE_URL } = urls || {};

function* deleteCourse({ data }) {
  const {
    payload: { current, pageNumber },
    callBack,
  } = data;

  const url = `${API_BASE_URL}/courses/${current.id}`;

  const response = yield request({
    method: 'delete',
    url,
  });
  if (response.success) {
    Notify('Course Deleted Successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    yield put(getCourse(pageNumber));
    yield put(getAllCourses());
    yield put(clearStatus());
    if (response.statusCode === 204) {
      yield put(setDeleteSuccess(response.statusCode));
      callBack();
    }
  } else {
    // eslint-disable-next-line no-lonely-if
    if (response.statusCode === 409) {
      yield put(
        setDeleteError(
          'This course cannot be deleted as it is tied to one or more applicant(s)'
        )
      );
    }
  }
}

export function* onDeleteCourse() {
  yield takeLatest(CoursesActionTypes.DELETE_COURSE, deleteCourse);
}
